enum ActionType {
    SET_CMS_PREVIEW = 'PreferencesActions.SET_CMS_PREVIEW',
}

export default ActionType;
